export const deriveTableDisplayName = ({
  seatedTableName,
  isMultiTable,
  listingName,
}: {
  seatedTableName: string | null;
  isMultiTable: boolean;
  listingName: string;
}): string => {
  return seatedTableName ?? (isMultiTable ? 'Multiple' : listingName);
};
